import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  standalone: true
})

export class HomePageComponent implements OnInit {
  title = 'FrameworkUI';

  constructor() { }

  ngOnInit(): void {
  }

}
